import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService, CredentialsForm } from '@core/auth';
import { ModalController } from '@ionic/angular';
import { LoadingService } from '@shared/loading';
import { OlvidePasswordComponent } from '@shared/seguridad/olvide-password/olvide-password.component';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/shared/events/toast.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.page.html',
  styleUrls: ['./sign-in.page.scss'],
})
export class SignInPage implements OnInit
{
  ojoAbierto:boolean = true;
  loginForm: FormGroup = new FormGroup<CredentialsForm>({
    username: new FormControl('',[Validators.required]),
    password: new FormControl('', [Validators.required]),
    grant_type: new FormControl('password'),
  });

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private toastService: ToastService,
    private _loading: LoadingService,
    private _modalController: ModalController
  ) { }

  ngOnInit() { }

  async onSubmit() {
    await this.updateAllValuesAndValidity();
  
    if (this.loginForm.invalid) return;
  
    this._loading.isLoading = true;
  
    this._authService.signIn(this.loginForm.value)
      .pipe(finalize(() => this._loading.isLoading = false))
      .subscribe({
        next: (mfa) => {
          this._resetForm();
  
          if (mfa.app) return this._router.navigate(['/multi-fa']);
          if (mfa.sms) return this._router.navigate(['/multi-fa/sms']);
          if (mfa.email) return this._router.navigate(['/multi-fa/email']);
  
          this._router.navigate(['/orgs-board']);
        },
        error: (error) => {
          console.log(error);
          if (error?.status === 400) {
            this.toastService.toastWarning(error?.error);
          } else {
            this.toastService.toastWarning(error?.error);
            this._resetPassword();
          }
        }
      });
  }
  
  

  onInput(event: Event, propiedad: string) {
    const inputElement = event.target as HTMLInputElement;
    this.loginForm.get(propiedad)?.setValue(inputElement.value);
  }

  updateAllValuesAndValidity() {
    Object.keys(this.loginForm.controls).forEach(key => {
      const control = this.loginForm.get(key);
      if (control) {
        control.updateValueAndValidity();
      }
    });
  }

  private _resetPassword()
  {
    this.loginForm.controls.password.reset();
  }

  private _resetForm()
  {
    this.loginForm.enable();
    this.loginForm.reset();
  }

  public irCrearCuenta()
  {
    window.location.href = '/#/sign-up';
  }

  public irCentroAyuda()
  {
    window.open('https://admin.yalocobro.com/#/help', '_blank');
  }

  public recuperarPassword()
  {
    console.log('recuperar password');
  }

  async presentOlvidePassword()
  {

    const modal = await this._modalController.create({
      component: OlvidePasswordComponent,
      cssClass: 'auto-height',
      componentProps: {
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (!data)
    {
      return;
    }

    if (data)
    {
    }
  }
}
